import { createClientConfig } from "@repo/design-system/lib/client-registry";
import FilterbarEonHungary from "~/components/job-board/subclients/hungary/filterbar-eon-hungary";
import { JoblistEonHungary } from "~/components/job-board/subclients/hungary/joblist-eon-hungary";
import TeaserBarEonHungary from "~/components/job-board/subclients/hungary/teaserbar-eon-hungary";
import { UnifiedJobPageTemplate } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import FooterEonHungary from "~/components/page-skeleton/subclients/hungary/footer-eon-hungary";
import HeaderMainEonHungary from "~/components/page-skeleton/subclients/hungary/header-main-eon-hungary";
import { hungaryDefault } from "./default";
import { hungaryTrainee } from "./trainee";

export const hungary = createClientConfig({
  components: {
    JobpageTemplate: UnifiedJobPageTemplate,
    Filterbar: FilterbarEonHungary,
    Joblist: JoblistEonHungary,
    HeaderMain: HeaderMainEonHungary,
    Footer: FooterEonHungary,
    TeaserBar: TeaserBarEonHungary,
  },
  ui: {},
  // hungaryTrainee first (different sectionBar); hungaryDefault catches all remaining Hungary jobs.
  subtemplates: [hungaryTrainee, hungaryDefault],
});
